import { CommonModule, LowerCasePipe } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    imports: [CommonModule, LowerCasePipe],
    selector: 'ge-card',
    templateUrl: './ge-card.html',
    standalone: true
})
export class GeCardComponent implements OnInit {
  appURL: string = environment.appURL;
  mediaURL: string = environment.mediaURL;
  @Input() code: string = '';
  @Input() country: string = '';
  @Input() location: string = '';
  @Input() slug: string = '';
  @Input() option: number = 0;
  @Input() category: string = '';
  @Input() service: string = '';
  @Input() skill: string = '';
  @Input() skillslug: string = '';
  @Input() placeholder: boolean = false;

  title: string = '';
  phrase: string = '';
  overview: string = '';
  url: string = '';

  constructor(
  ) {}

  ngOnInit() {
    if(this.service === 'gigs') {
      if (this.option === 0) {
        this.phrase = 'Looking for someone to help me with ';
      } else if (this.option === 1) {
        this.phrase = 'Needing help with ';
      } else if (this.option === 2) {
        this.phrase = 'Wanting to hire for ';
      } else if (this.option === 3) {
        this.phrase = 'Need extra income work? We can help! We are looking for ';
      } else if (this.option === 4) {
        this.phrase = 'Looking to hire an expert ';
      } else if (this.option === 5) {
        this.phrase = 'Hire & Recruit Local & Remote ';
      }
    } else if(this.service === 'jobs') {
      if (this.option === 0) {
        this.phrase = 'On the hunt for an experienced ';
      } else if (this.option === 1) {
        this.phrase = 'Wanted. We are wanting to hire ';
      } else if (this.option === 2) {
        this.phrase = 'Our client is wanting to recruit an expert ';
      } else if (this.option === 3) {
        this.phrase = 'A large corporate is looking to hire multiple ';
      } else if (this.option === 4) {
        this.phrase = 'Searching for a contractor ';
      } else if (this.option === 5) {
        this.phrase = 'Looking for an expert ';
      }
    } else if(this.service === 'volunteers') {
      if (this.option === 0) {
        this.phrase = 'Need a volunteer to help our charity with ';
      } else if (this.option === 1) {
        this.phrase = 'Wanting to volunteer and add value to your community? Advertise your ';
      } else if (this.option === 2) {
        this.phrase = 'Small charity, looking for a volunteer to help ';
      } else if (this.option === 3) {
        this.phrase = 'Community group needing volunteer assistance to help with ';
      } else if (this.option === 4) {
        this.phrase = 'Expert would love to help volunteer my services for a good cause ';
      } else if (this.option === 5) {
        this.phrase = 'Sign Up to volunteer ';
      }
    } else if(this.service === 'promote') {
      if (this.option === 0) {
        this.phrase = 'Available for Hire! Need help with ';
      } else if (this.option === 1) {
        this.phrase = 'Expert freelancer available for hire ';
      } else if (this.option === 2) {
        this.phrase = 'Do you require expert business advise and assistance? ';
      } else if (this.option === 3) {
        this.phrase = 'Looking for help with ';
      } else if (this.option === 4) {
        this.phrase = 'Advertise your small business  ';
      } else if (this.option === 5) {
        this.phrase = 'Need an expert contractor available for hire ';
      } else if (this.option === 6) {
        this.phrase = 'Wanted. We are wanting to find ';
      }
    }
    this.title = this.skill;
    this.overview = this.phrase + this.skill + ' in ' + this.country;
    if (this.skillslug && this.category) {
      this.url = '/' + this.service + '/' + this.category + '/' + this.skillslug + '/' + this.slug;
    } else if (this.skillslug) {
      this.url = '/' + this.service + '/' + this.skillslug + '/' + this.slug;
    } else if (this.placeholder) {
      this.overview = 'Place your ' + (this.skill=='' ? '' : this.skill) + ' ' + this.service + ' Ad here and reach millions of our customers' + (this.location ? ' in ' + this.location : this.country=='Global' ? '' : ' in ' + this.country) + ' and beyond. Sign Up and advertise on gigexchange today.';
      this.title = (this.skill=='' ? this.service : this.skill);
      this.url = this.appURL + '/sign-up';
    } else {
      let url = this.skill.split(', ').join('-');
      url = url.split(' & ').join('-');
      url = url.split(' ').join('-');
      url = url.split('--').join('-');
      url = url.toLowerCase();
      this.url = '/' + this.service + '/' + url + '/' + this.slug;
    }
  }
}
